import { render, staticRenderFns } from "./QuizReview.vue?vue&type=template&id=63b7528a&scoped=true&"
import script from "./QuizReview.vue?vue&type=script&lang=js&"
export * from "./QuizReview.vue?vue&type=script&lang=js&"
import style0 from "./QuizReview.vue?vue&type=style&index=0&id=63b7528a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b7528a",
  null
  
)

export default component.exports